export const defaultValues = {
  reservationCode: '',
  message: '',
  voebizCode: '',
  solicitationType: '',
  subject: '',
  category: '',
  subCategory: '',
};
